module.exports = __webpack_public_path__ + "img/vivo1.b660b38a.png";